export default "__VITE_ASSET__BFRmD$E5__"